import {compact} from '@benchling/js-utils';

import * as analytics from 'analytics/Analytics';
import {SchemaTag} from 'folder-items/FileConstants';
import {Note} from 'notebook/util/NoteUtilConstants';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import runModal from 'ui-library/runModal';

import AddSamplesFromStructuredTableModal from '../add-samples-modal/AddSamplesFromStructuredTableModal';
import {SampleFilter, SampleFilters} from '../SampleFilter';
import {addSamplesToTag} from './addSamplesToTagUtils';

interface PartialModalProps {
  title: string;
  entryId: string;
  destinationSampleType: SampleFilter | null;
}

export default async function addSamplesFromTableToTag(
  note: Note,
  sourceTag: SchemaTag,
  fieldType: FieldType,
  sampleFilters: SampleFilters,
  props: PartialModalProps
): Promise<SchemaTag | null> {
  let newTag = null;
  await runModal(AddSamplesFromStructuredTableModal, {
    ...props,
    note,
    limitSamplesTo: sampleFilters,
    onRequestSubmit: ({samples}) => {
      newTag = addSamplesToTag(compact(samples), sourceTag, fieldType);
    },
    sessionId: analytics.makeAnalyticsEventId(),
  });

  return newTag;
}
